import React, { createContext, useContext, useState, useCallback } from "react";
import { post } from "@/lib/api";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("rt_lang") || "en");
  const setLang = (l) => { localStorage.setItem("rt_lang", l); setLangState(l); };

  // Translate an entity to the current language (cached server-side). Returns {} for English.
  const translate = useCallback(async (entity_type, entity_id) => {
    if (lang === "en") return {};
    try { return await post("/i18n/translate", { entity_type, entity_id, target: lang }); }
    catch { return {}; }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, translate }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
